import React from "react";
import {createUseStyles} from "react-jss";
import {mediaSizes} from "~/theme";

export default function LoginSceneLayout({children}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {children}
      </div>
    </div>
  )
}


const useStyles = createUseStyles({
  root: {
    minHeight: '100%',
    position: 'relative',
    boxSizing: 'border-box',
    padding: [[180, 0, 80]],

    '&:before': {
      content: "\"\"",
      position: 'absolute',
      left: 0,
      top: 0,
      height: 280,
      width: '100%',
      borderBottom: [[1, 'solid', '#DDD']],
      background: 'linear-gradient(to right, #DFDFDF 0%, #DFDFDF 25%, #E7E7E7 26%, #E7E7E7 100%)',
      backgroundSize: [[4, 10]],
      zIndex: -1,
      fallbacks: [
        {background: '#E7E7E7'}
      ],
    },

    '&:after': {
      content: "\"\"",
      position: 'absolute',
      left: 0,
      bottom: 0,
      height: '100%',
      width: '100%',
      zIndex: -2,
      backgroundColor: '#F3F3F3',
    }
  },

  container: {
    margin: [[0, 'auto']],
    background: '#fff',
    width: 720,
    padding: [[36, 48, 48]],
    minHeight: 420,
    position: 'relative',
    borderRadius: 10,
    boxShadow: [[0, 0, 7, 1, '#9B9B9B']],
    boxSizing: 'border-box',

    [mediaSizes['sm']]: {
      width: 480,
    },

    [mediaSizes['xs']]: {
      width: 320,
    },

    '&:before': {
      content: "\"\"",
      position: 'absolute',
      left: '50%',
      top: 0,
      transform: 'translate(-50%, -100%)',
      marginLeft: -10,
      marginTop: 25,
      width: 161,
      height: 169,
      background: 'url(https://app.workshopbutler.com/assets/images/generated/common/icon-logo.png) no-repeat',
      backgroundSize: 'cover'
    }
  }
});
